<template>
  <div
    data-page-parts-id="modalBanner"
    :class="[$style.page_parts_modal_banner_image, { [$style.along_width_editor_text]: !!alongWidthEditorText }]"
  >
    <div :class="$style.image" @click.prevent="modalOpen = true">
      <AtomsConsumerImage :src="imageUrl(bannerImage)" alt="" :class="$style.modal_image" :width="1280" />
      <AtomsConsumerImage
        :src="spImageUrl(spBannerImage, bannerImage)"
        alt=""
        :class="$style.sp_modal_image"
        :width="768"
      />
    </div>
    <MoleculesConsumerModal v-model="modalOpen">
      <AtomsConsumerImage :src="imageUrl(modalImage)" alt="" :class="$style.modal_image" :width="1280" />
      <AtomsConsumerImage
        :src="spImageUrl(spModalImage, modalImage)"
        alt=""
        :class="$style.sp_modal_image"
        :width="768"
      />
    </MoleculesConsumerModal>
  </div>
</template>

<script setup lang="ts">
type Props = {
  bannerImage?: string
  spBannerImage?: string
  modalImage?: string
  spModalImage?: string
  alongWidthEditorText?: boolean // EditorTextページパーツの文面と同じ幅にします
}

defineProps<Props>()

const modalOpen = ref(false)
const imageUrl = (url: string | undefined): string => {
  return url || "/images/common/no-image.png"
}
const spImageUrl = (url: string | undefined, pcUrl: string | undefined): string => {
  const pcImage = pcUrl || "/images/common/no-image.png"
  return url || pcImage
}
</script>

<style scoped module lang="scss">
.page_parts_modal_banner_image {
  .image {
    @include container-lg;
    cursor: pointer;
    > img {
      width: 100%;
      height: auto;
    }
  }
  .image:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease-out 0s;
  }
  .modal_image {
    display: none;
    width: 100%;
    @include md {
      display: block;
    }
  }
  .sp_modal_image {
    width: 100%;
    @include md {
      display: none;
    }
  }
}

.along_width_editor_text {
  padding: 0 2.3125rem; // editor_textに合わせる
  width: calc(342px + 2.3125rem * 2);

  @include md {
    width: calc(696px + 2.3125rem * 2);
  }
}
</style>
